"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
const radioWidth = 45;
exports.StyledFormRadio = styled_1.default.div `
	.radio {
		cursor:pointer;
		}

	.radio__container {
		display: flex;
		align-items: center;
	}

	.radio__input-wrapper {
		position: relative;
	}

	/* Hide default radio button but allow for tab selection */
	.radio__input {
		z-index: -1;
		position: absolute;
		top: ${`${radioWidth / 2 - 5}px`};
		left: ${`${radioWidth / 2 - 5}px`};
	}

	/*
	This radio__button selector only handles the outline of the
	button, the radio__button:before is the thicker inner border
	*/
	.radio__button {
		flex: none;
		margin-right: 10px;
		position: relative;
		box-sizing: border-box;
		background: white;
		border: 1px solid ${theme_1.palette.greyscale.medium};
		width: 45px;
		height: 45px;
		border-radius: 50%;
	}
	.radio__button:before {
		flex: none;
		box-sizing: border-box;
		width: ${`${radioWidth}px`};
		height: ${`${radioWidth}px`};
		border-radius: 50%;
		content: "";
		display: block;
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
	}

	/*
	Checked and focus behaviour.  Focus changes the outline colour
	and checked has a wide inner border.  Note the outline is
	widened when checked & focussed to blend the two borders better
	*/
	.radio__input:checked + .radio__button:before {
	border: 15px solid ${theme_1.default.colours.primary.default};
	}
	.radio__input:focus + .radio__button {
		border: 1px solid ${theme_1.default.colours.primary.default};
		outline: none;
	}
	.radio__input:checked:focus + .radio__button {
		border: 4px solid ${theme_1.default.colours.primary.default};
	}
	/* the offsets below need to be the border width above minus 1 */
	.radio__input:checked:focus + .radio__button:before {
		top: -3px;
		left: -3px;
	}

	.radio__wrapper {
		margin-top: 10px;
	}

	.radio__wrapper-horizontal {
		flex: 1 0 50%;
	}
`;
//# sourceMappingURL=form-radio.styled.js.map